// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1wv7N","footer":"ModalInfo_footer__2sI-O"};